import * as React from 'react';
import queryString from 'query-string'
import '../../css/powerbi.css'
import PowerBIFNTDashboard from '../i4Reports/PowerBIFNTDashboard';




export default class FNTDashboard extends React.Component<any, any> {
  public constructor(props: any) {
      super(props);
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <PowerBIFNTDashboard />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/app/FNTDashboard.tsx